module.exports = __webpack_public_path__ + "media/components/swell-preview/static/surfscale-imperial-f7e53572998fe85c517206306432250b.svg";